import React from 'react'
import styled from 'react-emotion'
import { mediaDn, spacer } from 'stylist'
import FooterLink from './FooterLink'

const Container = styled.section`
  padding-top: ${spacer(6)};
  padding-bottom: ${spacer(6)};

  display: flex;
  justify-content: center;

  ${mediaDn('sm')} {
    flex-direction: column;
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: center;

    ${mediaDn('sm')} {
      grid-template-columns: 1fr;
    }
  }
`

const HomeFooter = () => (
  <Container>
    <FooterLink href="https://support.focusvision.com/">Support</FooterLink>

    <FooterLink href="https://www.focusvision.com/privacy-statement/">
      Privacy Policies
    </FooterLink>

    <FooterLink href="https://www.focusvision.com/terms-and-conditions/">
      Terms and Conditions
    </FooterLink>
  </Container>
)

export default HomeFooter



// WEBPACK FOOTER //
// ./src/routes/components/FooterHome.js